import { TruncateTextWithTooltip } from '@/components/ui/truncate-text-with-tooltip';

type ChartCategoryAxisTickProps = {
  x?: string | number;
  y?: string | number;
  payload?: { value?: string };
  /** Reserved axis label width; keep in sync with YAxis `width`. */
  tickWidth?: number;
};

/**
 * Y-axis category tick for vertical bar charts. Truncates long labels inside the
 * axis band and shows the full value on hover when clipped.
 */
export function ChartCategoryAxisTick({
  x = 0,
  y = 0,
  payload,
  tickWidth = 152,
}: ChartCategoryAxisTickProps) {
  const label = payload?.value;
  if (!label) return null;

  const numericX = Number(x);
  const numericY = Number(y);
  const rowHeight = 20;

  return (
    <foreignObject
      x={numericX - tickWidth}
      y={numericY - rowHeight / 2}
      width={tickWidth}
      height={rowHeight}
    >
      <div className='flex h-full items-center justify-end pr-1'>
        <TruncateTextWithTooltip
          text={label}
          className='block max-w-full text-right text-xs text-muted-foreground'
        />
      </div>
    </foreignObject>
  );
}
